/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Scene_Change_Detection_Thumbnail_Progress_StatusInputs */



/**
* | output |
* | --- |
* | "Generating marker thumbnails {current}/{total}" |
*
* @param {Scene_Change_Detection_Thumbnail_Progress_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_thumbnail_progress_status = /** @type {((inputs: Scene_Change_Detection_Thumbnail_Progress_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Thumbnail_Progress_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Génération des vignettes de marqueurs ${i?.current}/${i?.total}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Marker-Miniaturbilder werden erstellt ${i?.current}/${i?.total}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Generazione miniature dei marcatori ${i?.current}/${i?.total}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Создание миниатюр маркеров ${i?.current}/${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Generando miniaturas de marcadores ${i?.current}/${i?.total}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在生成标记缩略图 ${i?.current}/${i?.total}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`マーカーサムネイルを生成中 ${i?.current}/${i?.total}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`मार्कर थंबनेल बनाए जा रहे हैं ${i?.current}/${i?.total}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A gerar miniaturas dos marcadores ${i?.current}/${i?.total}`)
	return /** @type {LocalizedString} */ (`Generating marker thumbnails ${i?.current}/${i?.total}`)
});